import { ParentCampaignActions as Actions } from './ParentCampaignActions';

export const ParentCampaignActions = ({
  data,
  onEdit,
  onDuplicate,
  actions,
  limit,
}) => {
  const handleEdit = () => onEdit(data);
  const handleDuplicate = () => onDuplicate(data);

  return (
    <Actions
      onEdit={handleEdit}
      onDuplicate={handleDuplicate}
      actions={actions}
      limit={limit}
    />
  );
};
